<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)" [hideLegend]="true"></eaglei-leaflet-layer-header>

<ng-container *ngIf="mapControls.filterGroup && isActive">
    <form [formGroup]="mapControls.filterGroup">
        <mat-form-field [class.active]="mapControls.filterGroup.controls.type.value">
            <mat-label>Event Type</mat-label>
            <mat-select [compareWith]="systemEventService.typeCompareFunction" placeholder="Event Type" formControlName="type">
                <mat-option *ngFor="let eventType of eventTypes()" [value]="eventType">
                    {{ eventType.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field [class.active]="mapControls.filterGroup.controls.name.value">
            <mat-label>Event Name</mat-label>
            <mat-select placeholder="Event name" formControlName="name">
                <mat-optgroup *ngFor="let group of mapControls.eventGroups() | keyvalue" [label]="group.key | titlecase">
                    <mat-option *ngFor="let event of mapControls.eventGroups()[group.key]" [value]="event">{{ event.name }} </mat-option>
                </mat-optgroup>
            </mat-select>
        </mat-form-field>

        <mat-form-field [class.active]="mapControls.filterGroup.controls.advisory.value">
            <mat-label>Advisory</mat-label>
            <mat-select placeholder="Advisory" formControlName="advisory">
                <mat-option *ngFor="let result of mapControls.selectedDetail" [value]="result">
                    {{ result.resultId }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>

    <div #legendElement>
        <div class="legends">
            <span class="legend-title">Predicted Outage Percentages:</span>
            <div class="customer-out-legend">
                <div
                    class="color-blocks"
                    *ngFor="let percentage of styleService.percentOutDomain; let first = first; let last = last"
                    [class.first-block]="first"
                    [class.last-block]="last"
                    [style.background-color]="percentage.color">
                    <span class="text">{{ percentage.value }}</span>
                </div>
            </div>
        </div>

        <div class="legends advisory-legend">
            <div>
                <div class="color-dot" style="background-color: #ff0000"></div>
                <span class="legend-title"> Advisory</span>
            </div>

            <div>
                <div class="color-dot" style="background-color: #003366"></div>
                <span class="legend-title"> Selected Advisory</span>
            </div>
        </div>
    </div>
</ng-container>
